//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "projectSelct",
  props: {
    onSelected: Function,
  },
  data() {
    return {
      options: [],
      projects: [],
      value1: 0,
      show: false,
    };
  },
  methods: {
    getProjects() {
      let page = {
        maxResultCount: 20,
        skipCount: 0,
      };
      abp.ajax
        .post("/api/services/app/Project/SearchProjects", page)
        .then((res) => {
          this.projects = [];
          this.projects.push(...res.data.result.items);
          this.options = this.projects.map((item, index) => {
            return {
              id: item.id,
              text: item.name,
              value: item.id,
            };
          });
          if (this.value1 == 0) {
            this.value1 = this.options[0].value;
          }
          // console.log(this.option1)
          // this.value1 = this.options[0].value;
        });
    },
    onDropdownItemChange(v) {
      console.log(v);
      let p = this.projects.find((z) => z.id == v);
      if ((p.cityName == "长沙市" ||  p.cityName == "株洲市")) {
        this.show = true;
        return;
      }

      localStorage.setItem("Select-ProjectId", v);
      var memberId = localStorage.getItem("MemberId");

      abp.ajax.post("/api/services/app/Member/SaveLastProjectId", {
        id: parseInt(memberId),
        lastProjectId: parseInt(v),
      });
      const vm = this;
      if (vm.onSelected !== undefined) {
        vm.onSelected(v);
      }
    },
  },
  created() {
    this.getProjects();
    var projectId = localStorage.getItem("Select-ProjectId");
    if (projectId != undefined || projectId != null) {
      this.value1 = parseInt(projectId);
    }
  },
};
